import { Component } from '@angular/core';
import { ColumnNumberDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-number',
  templateUrl: './ap-column-number.component.html',
})
export class ApColumnNumberComponent extends ApColumnBase<ColumnNumberDto> {
  displayNum: number;
  load() {
    this.displayNum = this.columnInfoDto.Callback(this.dataItem);
  }
}
